/**
 * KisiKurallariPage.jsx — Kişi Kuralları (backlog #385). Rota: /Management/Kisi/Kurallar (page.kisi);
 * menüde Sistem Ayarları › Kişi Kuralları.
 *
 * Eskiden "Kişiler" menüsünün altındaki iki ayrı ekran tek sayfada, iki sekme olarak toplandı:
 *   · Meslek Kuralları        (?tab=meslek) — MeslekYonetimPage, meslek başına belge kümesi (fuar / genel kural)
 *   · Kişi Künye Bilgileri    (?tab=kunye)  — BilgiKategorileriPage, yerleşik künye alanları + ek alan kataloğu
 * Sekmeler sayfanın kendi `embedded` kabuğuyla çizilir (Components/Common/EmbeddablePage); veri çekme ve modal'lar
 * kendi dosyalarında kaldı. Yalnızca AÇIK sekme monte edilir: iki sayfa da açılırken kendi okumasını yapar.
 *
 * `?fuarId=` Meslek sekmesinin kapsam seçicisine aittir (MeslekYonetimPage okur ve yazar); sekme değişince korunur.
 * Eski /Management/Kisi/Meslekler ve /Management/Kisi/BilgiKategorileri adresleri `KisiKurallariRedirect` ile buraya
 * yönlenir (sorgu dizesi korunur). Üçüncü bir sekme (ör. #386'daki yabancı firma / kişi kuralları) eklemek için
 * `TABS`'a bir satır ve aşağıdaki `ICERIK`'e bir giriş yeterli.
 */
import React, { useEffect } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { Card, Container, Nav, NavItem, NavLink } from "reactstrap";
import { Briefcase, IdCard } from "lucide-react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import MeslekYonetimPage from "./MeslekYonetimPage";
import BilgiKategorileriPage from "./BilgiKategorileriPage";

const TABS = [
  { key: "meslek", label: "Meslek Kuralları", Icon: Briefcase },
  { key: "kunye", label: "Kişi Künye Bilgileri", Icon: IdCard },
];

const ICERIK = {
  meslek: <MeslekYonetimPage embedded />,
  kunye: <BilgiKategorileriPage embedded />,
};

/** Eski tek sayfalık adresleri sorgu dizesini koruyarak ilgili sekmeye yönlendirir. */
export function KisiKurallariRedirect({ tab }) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set("tab", tab);
  return <Navigate to={`/Management/Kisi/Kurallar?${params.toString()}`} replace />;
}

export default function KisiKurallariPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = TABS.some((t) => t.key === searchParams.get("tab")) ? searchParams.get("tab") : TABS[0].key;

  useEffect(() => { document.title = "Kişi Kuralları | FDS"; }, []);

  function setTab(key) {
    const next = new URLSearchParams(searchParams);
    next.set("tab", key);
    setSearchParams(next, { replace: true });
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Kişi Kuralları" pageTitle="Sistem Ayarları" />

        <Card className="mb-3">
          <Nav tabs className="nav-tabs-custom border-bottom-0 px-3">
            {TABS.map((t) => (
              <NavItem key={t.key}>
                <NavLink
                  href="#"
                  className={`fw-semibold d-inline-flex align-items-center gap-1 ${activeTab === t.key ? "active" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={(e) => { e.preventDefault(); setTab(t.key); }}
                >
                  <t.Icon size={14} />{t.label}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Card>

        {ICERIK[activeTab]}
      </Container>
    </div>
  );
}
